// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"MyBalance__balanceWrapper--2Lm","icon":"MyBalance__icon--2n5","balance":"MyBalance__balance--4Pq","balanceLow":"MyBalance__balanceLow--3aR"};